import axios from 'axios';
import qs from "qs";

export async function getCardsStatistics({ range }) {
  const filter = {};
  if (range) {
    filter.created_at_range = range;
  }
  const { data: { data } } = await axios.get('/api/v1/cards/statistics', {
    params: { filter },
    paramsSerializer: params => qs.stringify(params),
  });
  return Array.isArray(data) && data[0];
}



// WEBPACK FOOTER //
// ./src/service/cards.js